export const CHAT_PAGE_SIZE = 50;

export const CHAT_STARTED_TYPE = 'ai_chat_started';
export const CHAT_RETRIED_TYPE = 'ai_chat_retried';
export const CHAT_FAILED_TYPE = 'ai_chat_failed';
export const CHAT_COMPLETED_TYPE = 'ai_chat_completed';
export const CHAT_RECEIVE_MESSAGE_TYPE = 'receive_ai_message';
export const CHAT_SEND_MESSAGE_TYPE = 'send_ai_message';
export const CHAT_RESPONSE_DELTA_TYPE = 'response.output_text.delta';
export const CHAT_RESPONSE_COMPLETED_TYPE = 'response.completed';

export const ChatMergeMode = {
    PREPEND: 'prepend',
    REPLACE: 'replace',
};

export const ChatRole = {
    USER: 'user',
    ASSISTANT: 'assistant',
    SYSTEM: 'system',
};

// Assistant chat runtime-specific constants.
export const ChatStartTimeoutMs = 45_000;
export const ChatCompletionTimeoutMs = 45_000;

export const ChatErrorKind = {
    DISCONNECTED: 'disconnected',
    GENERATION: 'generation',
    UNSUPPORTED_REQUEST: 'unsupported_request',
};

export const ChatErrorAction = {
    REFRESH: 'refresh',
    REGENERATE: 'regenerate',
};

export const ChatEventType = {
    LEGACY_DELTA: 'chat_delta',
    LEGACY_FINAL: 'chat_final',
};

export const RequestQueueItemType = {
    DELTA: 'delta',
    FAILED: 'failed',
    FINAL: 'final',
};

export const EmptyRuntimeResponse = { content: [] };
export const EmptyAssistantDraft = '';

export const UnsupportedRequestPatterns = [
    "couldn't help with your request",
    'try asking another question about your feedback',
    'bad faith',
    'not related to your feedback',
    'not related to the feedback',
    'policy',
    'unsafe',
];
